import { useEffect } from "react";
import Page from "../../components/Page";
import ComplianceReportSectionDetail from "../../components/Reports/complianceReport/ComplianceReportSectionDetail";
import CONFIG from "../../utils/config";

export const ComplianceReportDetailPageMobile = () => {

    useEffect(() => {
        window.scrollTo(0, 0);

        let sendHeight = setInterval(() => {
            let obj = { 'method': 'height', 'value': document.getElementById("root").scrollHeight }
            console.log('height: ', obj);
            window.parent.postMessage(obj, CONFIG.API_URL_BROKER_ADMIN);
        }, 3000)

        return (() => { clearInterval(sendHeight) })
    }, [])

    return (
        <ComplianceReportSectionDetail
            isMobile={true}
        />
    );
};

export default ComplianceReportDetailPageMobile;
